import { useEffect, useState } from "react";

export function useGoalGraphData(data: any) {
    const [graphData, setGraphData] = useState([]);

    useEffect(() => {
        let accViews = 0,
            accWebViews = 0,
            accAppViews = 0,
            accTotalVideoViews = 0,
            accTotalConversions = 0,
            accTotalReadingTime = 0;

        const risingGraph = data.graph?.reduce((a: any, b: any) => {
            a.push({
                date: b.date,
                totalViews: (accViews += b.totalViews),
                totalWebViews: (accWebViews += b.totalWebViews),
                totalAppViews: (accAppViews += b.totalAppViews),
                totalVideoViews: (accTotalVideoViews += b.totalVideoViews),
                conversion: (accTotalConversions += b.conversion),
                totalReadingTime: (accTotalReadingTime += b.totalReadingTime),
            });
            return a;
        }, []);
        setGraphData(risingGraph);
    }, [data]);

    return graphData;
}